/** Friendly labels for our own Microsoft Ads accounts, keyed by numeric AccountId.
 *  Any account not listed here falls back to its Microsoft account name (from the
 *  API's AccountName report column) — never the raw numeric id. */
export const ACCOUNT_LABEL: Record<string, string> = {
  "189315821": "$1",
  "189315822": "$2",
  "189349354": "$3",
  "189349356": "$4",
  "189349358": "$5",
};

export function accountLabel(accountId: string, accountName: string): string {
  if (ACCOUNT_LABEL[accountId]) return ACCOUNT_LABEL[accountId];
  return accountName.trim() || accountId;
}

// Fixed display order: normal Microsoft accounts first → $1 → $2 → $3 → $4 → $5.
export const ACCOUNT_RANK: Record<string, number> = {
  "189315821": 1,
  "189315822": 2,
  "189349354": 3,
  "189349356": 4,
  "189349358": 5,
};
export const accountRank = (id: string) => ACCOUNT_RANK[id] ?? 0;

/** Marke je Microsoft-Konto (Operator 2026-10-07): $5 testet die Vergleichsseiten mit AvaTrade auf Platz 1 und steht
 *  mit Kachel und Kosten in der AvaTrade-Karte. Alle anderen Konten gehoeren zu eToro. */
export const ACCOUNT_MARKE: Record<string, string> = { "189349358": "avatrade" };
export const accountMarke = (id: string) => ACCOUNT_MARKE[id] ?? "etoro";
